import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router';

import Button from '../UI/Button';
import { sendEvent2 } from '../../utils/tracking';

const Redirect: FunctionComponent<{ url: string; state?: any }> = ({ url, children, state }) => {
  const history = useHistory();
  const redirectPage = () => {
    history.push(url, state);
  };

  return (
    <Button
      variant="text"
      style={{ width: '100%', height: '100%' }}
      clickHandler={() => {
        setTimeout(redirectPage, 200);
        sendEvent2(
          'vehicle_card',
          {
            event_action: 'click',
            event_category: 'vehicle_card',
            screen_name: 'ft_homescreen',
            miscellaneous: JSON.stringify({
              auto_rchg: state.autoRecharge ? 'on' : 'off',
            }),
            target_product: 'fastag',
            event_platform: 'web',
          },
          true,
        );
      }}
    >
      {children}
    </Button>
  );
};

export default Redirect;
